"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12 4C9.79 4 8 5.79 8 8c0 2.13 2.08 5.47 4 7.91 1.92-2.44 4-5.78 4-7.91 0-2.21-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.89 2-2 2z",
  opacity: ".3"
}), _react.default.createElement("path", {
  d: "M5 20h14v2H5zm7-18C8.69 2 6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11c0-3.31-2.69-6-6-6zm0 13.91C10.08 13.47 8 10.13 8 8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.13-2.08 5.46-4 7.91zM12 6c-1.1 0-2 .9-2 2s.9 2 2 2c1.11 0 2-.9 2-2s-.9-2-2-2z"
})), 'PinDropTwoTone');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/PinDropTwoTone.js
// module id = 4757
// module chunks = 0